(function commonJS(require, module) {
    'use strict';

    require('./dist/angular-socialshare');

    module.exports = '720kb.socialshare';
}(require, module));



//////////////////
// WEBPACK FOOTER
// ./~/angular-socialshare/index.js
// module id = 376
// module chunks = 1